// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.card-container {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background: white;
  height: 475px;
  margin: 0 auto;
  margin-top: 20px;
  width: 100%;
  padding: 10px;
  position: relative;
}
.card-container .delete-container {
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 15px;
}
.card-container .delete-container .enrolled {
  border-radius: 5px 5px 0 0;
  background-color: #FEBF31;
  height: 16px;
  width: 100%;
}
.card-container .school-photo-container {
  border-radius: 10px;
  align-items: center;
  color: #19608f;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
.card-container .school-photo-container .school-logo {
  padding: 5px;
  border-top: 1px solid #A7A9AC;
  border-bottom: 1px solid #A7A9AC;
  display: flex;
  justify-content: center;
  width: 100%;
  contain: content;
}
.card-container .school-info-container {
  color: #19608f;
  margin-bottom: 10px;
}
.card-container .school-info-container .info {
  margin-bottom: 10px;
}
.card-container .school-info-container .info .school-name {
  font-weight: 650;
  height: 75px;
}
.card-container .school-info-container .info .school-grade {
  font-size: 0.9rem;
  font-weight: 550;
}
.card-container .school-info-container .info .school-grade span {
  margin-left: 10px;
  font-weight: 450;
}
.card-container .school-info-container .status-container {
  display: flex;
  font-size: 0.9rem;
  font-weight: 550;
  margin-bottom: 30px;
}
.card-container .school-info-container .status-container span {
  margin-left: 10px;
  margin-right: 10px;
  font-weight: 450;
}
.card-container .school-info-container .options {
  display: flex;
  flex-direction: column;
  font-weight: 550;
  margin-bottom: 10px;
}
.card-container .school-info-container .options span {
  font-size: 0.9rem;
  font-weight: 350;
}
.card-container .container {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}
.card-container .container .school-card-button-container {
  display: flex;
  justify-content: space-evenly;
  position: relative;
}

.static-card-container {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background: #fff;
  margin: 10px;
  padding: 40px 10px 10px 10px;
  position: relative;
  width: 300px;
}
.static-card-container .school-photo-container {
  border-radius: 10px;
  align-items: center;
  color: #19608f;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
.static-card-container .school-photo-container .school-logo {
  padding: 5px;
  border-top: 1px solid #A7A9AC;
  border-bottom: 1px solid #A7A9AC;
  display: flex;
  justify-content: center;
  width: 100%;
  contain: content;
}
.static-card-container .school-info-container {
  color: #19608f;
  margin-bottom: 10px;
}
.static-card-container .school-info-container .school-name {
  font-weight: 650;
  height: 70px;
}
.static-card-container .school-info-container .school-grade {
  font-size: 0.9rem;
  font-weight: 550;
  margin-bottom: 5px;
  height: 30px;
}
.static-card-container .school-info-container .school-grade span {
  margin-left: 10px;
  font-weight: 450;
}
.static-card-container .school-info-container .static-options {
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
  font-weight: 550;
  margin-bottom: 5px;
  height: 40px;
}
.static-card-container .school-info-container .static-options span {
  margin: 0 10px;
  font-weight: 350;
}
.static-card-container .school-info-container .center-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 30px;
  margin: 15px 0 15px 0;
  text-align: center;
  padding-bottom: 15px;
}
.static-card-container .school-info-container .status-container {
  font-size: 0.9rem;
  font-weight: 550;
  margin-bottom: 5px;
  height: 30px;
}
.static-card-container .school-info-container .status-container span {
  margin-left: 10px;
  font-weight: 450;
}
.static-card-container .container {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}
.static-card-container .container .school-card-button-container {
  display: flex;
  justify-content: space-evenly;
  position: relative;
}

@media only screen and (max-width: 1240px) {
  .card-container {
    font-size: 0.75rem;
    height: auto;
  }
  .card-container .school-info-container .info .school-name {
    font-size: 0.7rem;
  }
  .card-container .school-info-container .info .school-grade {
    font-size: 0.6rem;
  }
  .card-container .school-info-container .info .status-container {
    font-size: 0.6rem;
  }
  .card-container .school-info-container .info .options {
    font-size: 0.7rem;
  }
  .static-card-container {
    font-size: 0.75rem;
    width: 220px;
  }
  .static-card-container .school-info-container .school-name {
    font-size: 0.8rem;
    height: 50px;
  }
  .static-card-container .school-info-container .school-grade {
    font-size: 0.8rem;
    height: 300px;
  }
  .static-card-container .school-info-container .status-container {
    font-size: 0.8rem;
    height: 30px;
  }
  .static-card-container .school-info-container .static-options {
    font-size: 0.8rem;
    height: 30px;
  }
  .static-card-container .school-info-container .center-button {
    width: 100%;
    height: 30px;
    margin: 15px 0 15px 0;
    text-align: center;
    padding-bottom: 10px;
  }
}
@media only screen and (max-width: 1484px) {
  .static-card-container {
    font-size: 0.75rem;
    height: auto;
  }
  .static-card-container .school-info-container .school-name {
    font-size: 0.9rem;
    height: 50px;
  }
  .static-card-container .school-info-container .school-grade {
    font-size: 0.8rem;
    height: 30px;
  }
  .static-card-container .school-info-container .status-container {
    font-size: 0.9rem;
    height: 20px;
  }
  .static-card-container .school-info-container .static-options {
    font-size: 0.8rem;
    height: 30px;
  }
  .static-card-container .school-info-container .center-button {
    height: 30px;
    margin: 15px 0 15px 0;
    text-align: center;
    padding-bottom: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SchoolCard.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;ECAI,mBDCsB;ECoBtB,2CAAA;EDlBA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAUJ;AARI;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;AAUR;AARQ;EChBJ,0BDiB8B;EACtB,yBDJA;ECKA,YAAA;EACA,WAAA;AAUZ;AAPI;ECvBA,mBDwB0B;EACtB,mBAAA;EACA,cDrBE;ECsBF,aAAA;EACA,uBAAA;EACA,mBAAA;AASR;AAPQ;EACI,YAAA;EACA,6BAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AASZ;AALI;EACI,cDtCE;ECuCF,mBAAA;AAOR;AALQ;EACI,mBAAA;AAOZ;AANY;EACI,gBAAA;EACA,YAAA;AAQhB;AANY;EACI,iBAAA;EACA,gBAAA;AAQhB;AAPgB;EACI,iBAAA;EACA,gBAAA;AASpB;AALQ;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAOZ;AANY;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;AAQhB;AALQ;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAOZ;AANY;EACI,iBAAA;EACA,gBAAA;AAQhB;AAJI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AAMR;AAJQ;EACI,aAAA;EACA,6BAAA;EACA,kBAAA;AAMZ;;AADA;EChGI,mBDiGsB;EC5EtB,2CAAA;ED8EA,gBAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;AAIJ;AAHI;ECxGA,mBDyG0B;EACtB,mBAAA;EACA,cDtGE;ECuGF,aAAA;EACA,uBAAA;EACA,mBAAA;AAKR;AAJQ;EACI,YAAA;EACA,6BAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AAMZ;AAHI;EACI,cDrHE;ECsHF,mBAAA;AAKR;AAJQ;EACI,gBAAA;EACA,YAAA;AAMZ;AAJQ;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAMZ;AALY;EACI,iBAAA;EACA,gBAAA;AAOhB;AAJQ;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAMZ;AALY;EACI,cAAA;EACA,gBAAA;AAOhB;AAJQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;AAMZ;AAJQ;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAMZ;AALY;EACI,iBAAA;EACA,gBAAA;AAOhB;AAHI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AAKR;AAHQ;EACI,aAAA;EACA,6BAAA;EACA,kBAAA;AAKZ;;AAAA;EACI;IACI,kBAAA;IACA,YAAA;EAGN;EAAc;IACI,iBAAA;EAElB;EAAc;IACI,iBAAA;EAElB;EAAc;IACI,iBAAA;EAElB;EAAc;IACI,iBAAA;EAElB;EAGE;IACI,kBAAA;IACA,YAAA;EADN;EAIU;IACI,iBAAA;IACA,YAAA;EAFd;EAIU;IACI,iBAAA;IACA,aAAA;EAFd;EAIU;IACI,iBAAA;IACA,YAAA;EAFd;EAIU;IACI,iBAAA;IACA,YAAA;EAFd;EAIU;IACI,WAAA;IACA,YAAA;IACA,qBAAA;IACA,kBAAA;IACA,oBAAA;EAFd;AACF;AAOA;EACI;IACI,kBAAA;IAEA,YAAA;EANN;EAQU;IACI,iBAAA;IACA,YAAA;EANd;EAQU;IACI,iBAAA;IACA,YAAA;EANd;EAQU;IACI,iBAAA;IACA,YAAA;EANd;EAQU;IACI,iBAAA;IACA,YAAA;EANd;EAQU;IACI,YAAA;IACA,qBAAA;IACA,kBAAA;IACA,mBAAA;EANd;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.card-container {\n    @include borderRadius(10px);\n    @include shadow();\n    background: white;\n    height: 475px;\n    margin: 0 auto;\n    margin-top: 20px;\n    width: 100%;\n    padding: 10px;\n    position: relative;\n\n    .delete-container {\n        display: flex;\n        flex-direction: row-reverse;\n        margin-bottom: 15px;\n\n        .enrolled {\n            @include borderRadius(5px 5px 0 0);\n            background-color: $important;\n            height: 16px;\n            width: 100%;\n        }\n    }\n    .school-photo-container {\n        @include borderRadius(10px);\n        align-items: center;\n        color: $dk-blue;\n        display: flex;\n        justify-content: center;\n        margin-bottom: 15px;\n\n        .school-logo {\n            padding: 5px;\n            border-top: 1px solid $grey2;\n            border-bottom: 1px solid $grey2;\n            display: flex;\n            justify-content: center;\n            width: 100%;\n            contain: content;\n        }\n    }\n\n    .school-info-container {\n        color: $dk-blue;\n        margin-bottom: 10px;\n\n        .info {\n            margin-bottom: 10px;\n            .school-name {\n                font-weight: 650;\n                height: 75px;\n            }\n            .school-grade {\n                font-size: .90rem;\n                font-weight: 550;\n                span {\n                    margin-left: 10px;\n                    font-weight: 450;\n                }\n            }\n        }\n        .status-container {\n            display: flex;\n            font-size: .90rem;\n            font-weight: 550;\n            margin-bottom: 30px;\n            span {\n                margin-left: 10px;\n                margin-right: 10px;\n                font-weight: 450;\n            }\n        }\n        .options {\n            display: flex;\n            flex-direction: column;\n            font-weight: 550;\n            margin-bottom: 10px;\n            span {\n                font-size: .9rem;\n                font-weight: 350;\n            }\n        }\n    }\n    .container {\n        display: flex;\n        justify-content: center;\n        margin-top: 80px;\n\n        .school-card-button-container {\n            display: flex;\n            justify-content: space-evenly;\n            position: relative;\n        }\n    }\n}\n\n.static-card-container {\n    @include borderRadius(10px);\n    @include shadow();\n    background: #fff;\n    margin: 10px;\n    padding: 40px 10px 10px 10px;\n    position: relative;\n    width: 300px;\n    .school-photo-container {\n        @include borderRadius(10px);\n        align-items: center;\n        color: $dk-blue;\n        display: flex;\n        justify-content: center;\n        margin-bottom: 15px;\n        .school-logo {\n            padding: 5px;\n            border-top: 1px solid $grey2;\n            border-bottom: 1px solid $grey2;\n            display: flex;\n            justify-content: center;\n            width: 100%;\n            contain: content;\n        }\n    }\n    .school-info-container {\n        color: $dk-blue;\n        margin-bottom: 10px;\n        .school-name {\n            font-weight: 650;\n            height: 70px;\n        }\n        .school-grade {\n            font-size: .90rem;\n            font-weight: 550;\n            margin-bottom: 5px;\n            height: 30px;\n            span {\n                margin-left: 10px;\n                font-weight: 450;\n            }\n        }\n        .static-options {\n            display: flex;\n            flex-direction: column;\n            font-size: 0.9rem;\n            font-weight: 550;\n            margin-bottom: 5px;\n            height: 40px;\n            span {\n                margin: 0 10px;\n                font-weight: 350;\n            }\n        }\n        .center-button {\n            display: flex;\n            flex-direction: row;\n            justify-content: center;\n            width: 100%;\n            height: 30px;\n            margin: 15px 0 15px 0;\n            text-align: center;\n            padding-bottom: 15px;\n        }\n        .status-container {\n            font-size: .90rem;\n            font-weight: 550;\n            margin-bottom: 5px;\n            height: 30px;\n            span {\n                margin-left: 10px;\n                font-weight: 450;\n            }\n        }\n    }\n    .container {\n        display: flex;\n        justify-content: center;\n        margin-top: 80px;\n\n        .school-card-button-container {\n            display: flex;\n            justify-content: space-evenly;\n            position: relative;\n        }\n    }\n}\n\n@media only screen and (max-width: 1240px) {\n    .card-container {\n        font-size: 0.75rem;\n        height: auto;\n        .school-info-container {\n            .info {\n                .school-name {\n                    font-size: 0.7rem;\n                }\n                .school-grade {\n                    font-size: 0.6rem;\n                }\n                .status-container {\n                    font-size: 0.6rem;\n                }\n                .options {\n                    font-size: 0.7rem;\n                }\n            }\n        }\n    }\n    .static-card-container {\n        font-size: 0.75rem;\n        width: 220px;\n        // min-width: 200px;\n        .school-info-container {\n            .school-name {\n                font-size: 0.8rem;\n                height: 50px;\n            }\n            .school-grade {\n                font-size: 0.8rem;\n                height: 300px;\n            }\n            .status-container {\n                font-size: 0.8rem;\n                height: 30px;\n            }\n            .static-options {\n                font-size: 0.8rem;\n                height: 30px;\n            }\n            .center-button {\n                width: 100%;\n                height: 30px;\n                margin: 15px 0 15px 0;\n                text-align: center;\n                padding-bottom: 10px;\n            }\n        }\n    }\n}\n\n@media only screen and (max-width: 1484px) {\n    .static-card-container {\n        font-size: 0.75rem;\n        // width: 22%;\n        height: auto;\n        .school-info-container {\n            .school-name {\n                font-size: 0.9rem;\n                height:50px;\n            }\n            .school-grade {\n                font-size: 0.8rem;\n                height: 30px;\n            }\n            .status-container {\n                font-size: 0.9rem;\n                height: 20px;\n            }\n            .static-options {\n                font-size: 0.8rem;\n                height: 30px;\n            }\n            .center-button {\n                height: 30px;\n                margin: 15px 0 15px 0;\n                text-align: center;\n                padding-bottom: 5px;\n            }\n        }\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
